// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ResponseEnvironmentStatus } from './ResponseEnvironmentStatus';
import {
  ResponseEnvironmentStatusFromJSON,
  ResponseEnvironmentStatusFromJSONTyped,
  ResponseEnvironmentStatusToJSON,
  ResponseEnvironmentStatusToJSONTyped,
} from './ResponseEnvironmentStatus';
import type { ResponseEnvironmentMetadata } from './ResponseEnvironmentMetadata';
import {
  ResponseEnvironmentMetadataFromJSON,
  ResponseEnvironmentMetadataFromJSONTyped,
  ResponseEnvironmentMetadataToJSON,
  ResponseEnvironmentMetadataToJSONTyped,
} from './ResponseEnvironmentMetadata';
import type { ResponseEnvironmentSpec } from './ResponseEnvironmentSpec';
import {
  ResponseEnvironmentSpecFromJSON,
  ResponseEnvironmentSpecFromJSONTyped,
  ResponseEnvironmentSpecToJSON,
  ResponseEnvironmentSpecToJSONTyped,
} from './ResponseEnvironmentSpec';

/**
 *
 * @export
 * @interface ResponseEnvironment
 */
export interface ResponseEnvironment {
  /**
   *
   * @type {ResponseEnvironmentMetadata}
   * @memberof ResponseEnvironment
   */
  metadata?: ResponseEnvironmentMetadata;
  /**
   *
   * @type {ResponseEnvironmentSpec}
   * @memberof ResponseEnvironment
   */
  spec?: ResponseEnvironmentSpec;
  /**
   *
   * @type {ResponseEnvironmentStatus}
   * @memberof ResponseEnvironment
   */
  status?: ResponseEnvironmentStatus;
}

/**
 * Check if a given object implements the ResponseEnvironment interface.
 */
export function instanceOfResponseEnvironment(
  value: object,
): value is ResponseEnvironment {
  return true;
}

export function ResponseEnvironmentFromJSON(json: any): ResponseEnvironment {
  return ResponseEnvironmentFromJSONTyped(json, false);
}

export function ResponseEnvironmentFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ResponseEnvironment {
  if (json == null) {
    return json;
  }
  return {
    metadata:
      json['metadata'] == null
        ? undefined
        : ResponseEnvironmentMetadataFromJSON(json['metadata']),
    spec:
      json['spec'] == null
        ? undefined
        : ResponseEnvironmentSpecFromJSON(json['spec']),
    status:
      json['status'] == null
        ? undefined
        : ResponseEnvironmentStatusFromJSON(json['status']),
  };
}

export function ResponseEnvironmentToJSON(json: any): ResponseEnvironment {
  return ResponseEnvironmentToJSONTyped(json, false);
}

export function ResponseEnvironmentToJSONTyped(
  value?: ResponseEnvironment | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    metadata: ResponseEnvironmentMetadataToJSON(value['metadata']),
    spec: ResponseEnvironmentSpecToJSON(value['spec']),
    status: ResponseEnvironmentStatusToJSON(value['status']),
  };
}
